export enum SystemModule {
  REQUISITION = 'requisition',
  USER_ACCESS_CONTROL = 'uac',
  PRICING = 'pricing',
  CUSTOMER_STATEMENT = 'customer_statement',
  TEST = 'test',
  UTILITY = 'utility',
  SETTINGS = 'settings',
  CONTRACT_MANAGEMENT = 'contract_management',
  CLAIM_MANAGEMENT = 'claim_management',
  TRAVEL = 'travel',
  ACTIVITY_TRACKING = 'activity_tracking',
  SALES_ORDER = 'sales_order',
   ADVANCED_PAYMENT = 'advanced_payment',
}
